// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"d3-z"};